// extracted by mini-css-extract-plugin
export default {"icons":"styles_icons__cX0sK","selected-icons":"styles_selected-icons__jpXes"};